import { Injectable } from "@angular/core";
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from "@azure/msal-angular";
import { BrowserCacheLocation, InteractionType, IPublicClientApplication, PublicClientApplication } from "@azure/msal-browser";

import { AppConfigService } from "~/core/services/appconfig.service";

const API_SCOPE = 'https://digital-core-assist-dev.azure.chevron.com/user_impersonation';

@Injectable({
    providedIn: 'root'
})
export class AuthFactories {
    public initializerFactory(config: AppConfigService) {
        let promise = config.init();

        return () => promise;
    }

    public MSALInstanceFactory(config: AppConfigService): IPublicClientApplication {
        return new PublicClientApplication({
            auth: {
                clientId: config.getConfig("clientId"),
                authority: "https://login.microsoftonline.com/" + config.getConfig("tenantId"),
                redirectUri: '/',
                postLogoutRedirectUri: '/',
                navigateToLoginRequestUrl: true
            },
            cache: {
                cacheLocation: BrowserCacheLocation.SessionStorage,
                temporaryCacheLocation: BrowserCacheLocation.SessionStorage,
                storeAuthStateInCookie: false,
                secureCookies: true
            },
            system: {
                allowNativeBroker: false, // Disables WAM Broker
                loggerOptions: undefined
            }
        })
    }

    public MSALGuardConfigFactory(config: AppConfigService): MsalGuardConfiguration {
        return {
            interactionType: InteractionType.Redirect,
            authRequest: {
                scopes: ['openid', 'profile', 'email', API_SCOPE]
            },
            loginFailedRoute: '/'
        }
    }

    public MSALInterceptorConfigFactory(config: AppConfigService): MsalInterceptorConfiguration {
        const protectedResourceMap = new Map<string, Array<string>>();
        if (config.getConfig("authMode") === "local") {
            return {
                interactionType: InteractionType.Redirect,
                protectedResourceMap
            };
        }
        const apiUrl = (config.getConfig("apiUrl") || "").replace(/\/+$/, '');
        const scopes = [API_SCOPE];

        if (apiUrl) {
            protectedResourceMap.set(`${apiUrl}/*`, scopes);
            protectedResourceMap.set(apiUrl, scopes);
        }
        
        // ====================================================================
        // COMMENTED OUT: Microsoft Graph API - Requires admin consent
        // For open access without group checking, we don't need Graph API
        // ====================================================================
        // protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);

        return {
            interactionType: InteractionType.Redirect,
            protectedResourceMap: protectedResourceMap
        }
    }
}